import { AdFarmConfig } from "./AdFarmConfig";
import { AdFarmApiClient } from "./AdFarmApiClient";
import { MobileOverview, MobileRole } from "./AdFarmTypes";

export class RevenueRepository {
    constructor(private readonly api: AdFarmApiClient) {}

    overview(): Promise<MobileOverview> {
        return this.api.overview<MobileOverview>();
    }

    accountFor(overview: MobileOverview, role: MobileRole) {
        return role === "secondaryAgent" ? overview.secondaryAgent : overview.user;
    }

    startForegroundRefresh(onOverview: (overview: MobileOverview) => void, onError?: (error: Error) => void): void {
        this.stopForegroundRefresh();
        const refresh = async () => {
            if (typeof document !== "undefined" && document.hidden) return;
            try {
                onOverview(await this.overview());
            } catch (error) {
                onError?.(error as Error);
            }
        };
        refresh();
        Laya.timer.loop(AdFarmConfig.OVERVIEW_REFRESH_MS, this, refresh);
    }

    stopForegroundRefresh(): void {
        Laya.timer.clearAll(this);
    }
}
